// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__3NMu0","head":"ProcedureTableInfo_head__1fh-m"};